import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { ItemType } from 'app/common/ui-next/plain-selector'
import { api } from 'app/api'
import { OrgId } from 'app/common/types/id'

import {
  GET_SIGNATORES,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/schools/signatories/get'

import { orgsFilterSelection } from './orgsFilter'

type Signatores = Array<ItemType>

class FoodResponsibleSignatoresFilterDataBox extends DataBox<Signatores> {}

export const defaultFoodResponsibleSignatores: Signatores = []
export const foodResponsibleSignatoresFilter = createDataBox(
  'foodResponsibleSignatoresFilter',
  defaultFoodResponsibleSignatores,
  FoodResponsibleSignatoresFilterDataBox,
)

export const defaultFoodResponsibleSignatoresDataReceiver = async (
  orgsSelection?: Array<string>,
) => {
  const orgIds = orgsSelection || orgsFilterSelection.getData() || [null]
  const orgId = orgIds[0]
  if (!orgId) return []

  const res = await api.request(GET_SIGNATORES, {
    error: 'Не удалось получить данные ответственных по питанию',
    params: {
      orgId: orgId as OrgId,
    },
    convertions: {
      convertParams,
      convertResult,
    },
  })
  return res
    ? res.foodResponsibles.map(({ id, person }) => ({
        id: String(id),
        title: person.lastFirstMiddle,
      }))
    : []
}

foodResponsibleSignatoresFilter.addDataReceiver(defaultFoodResponsibleSignatoresDataReceiver)

export const defaultFoodResponsibleSignatoresSelection: Array<string> = []
export const foodResponsibleSignatoresFilterSelection = createDataBoxDefault<Array<string>>(
  'foodResponsibleSignatoresFilterSelection',
  defaultFoodResponsibleSignatoresSelection,
)
